import { render, staticRenderFns } from "./StarSpace.vue?vue&type=template&id=ae831490&scoped=true"
import script from "./StarSpace.vue?vue&type=script&lang=js"
export * from "./StarSpace.vue?vue&type=script&lang=js"
import style0 from "./StarSpace.vue?vue&type=style&index=0&id=ae831490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae831490",
  null
  
)

export default component.exports